import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const settings = {
  namespaced: true,
  state: {
    all: [],
    datas: [],
    queryParam: {},
    loading: false,
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async getById({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("settings/" + payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `settings/${payload[1]}`);
    },
    async update({ commit }, payload) {
      commit("SET_LOADING", true);
      return await AuthenticationService.put(
        "settings/" + payload.setting_id,
        payload
      )
        .then(({ data }) => {
          commit("SET_LOADING", false);
          alerts.sweetalertToast("success", data.message);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    onRefresh({ state }) {
      store.dispatch("settings/paginate", state.queryParam);
    },
  },
};

export default settings;
